import { render, staticRenderFns } from "./DonationCampaign.vue?vue&type=template&id=c238de54"
import script from "./DonationCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./DonationCampaign.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DonationCampaign.vue?vue&type=style&index=0&id=c238de54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports